import { Radio, RadioGroup } from '@headlessui/react'
import { CheckCircleIcon } from '@heroicons/react/16/solid'
import { ClockIcon } from '@heroicons/react/24/outline'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Badge } from '../../../../components'
import { Heading } from '../../../../components/ui/Heading'

export default function OptionMessage({ options }) {
  const [selected, setSelected] = useState({})
  const { t } = useTranslation()
  return (
    <div className='mt-2 flex flex-col gap-y-2'>
      <span className='animate-pulse text-xs font-semibold uppercase text-rockGrey'>
        {t('discover.assistant.radio_group.title')}
      </span>

      <RadioGroup
        by='title'
        value={selected}
        onChange={setSelected}
        className='space-y-4'
      >
        {options.map((option) => {
          const isSelected = selected.title === option.title
          return (
            <Radio
              key={option.title}
              disabled={option.disabled}
              value={option}
              onClick={option.onClick}
              className={clsx(
                'group flex cursor-pointer flex-col rounded-lg p-4 transition',
                isSelected
                  ? 'border-2 border-primaryBlue bg-[#F0F4FF]'
                  : 'border border-softGrey bg-white hover:border-2 hover:border-primaryBlue hover:bg-[#F0F4FF]',
                {
                  'cursor-not-allowed opacity-50': option.disabled
                }
              )}
            >
              <div className='flex flex-row items-start justify-between'>
                <Heading level={4}>{option.title}</Heading>
                {option.recommended && (
                  <Badge color={'green'} text={'Empfohlen'} />
                )}
                {isSelected && (
                  <CheckCircleIcon className='ml-1 size-4 text-primaryBlue' />
                )}
              </div>
              <p className='mt-2 text-sm font-normal text-rockGrey'>
                {option.description}
              </p>
              {option.time && (
                <div className='mt-2 flex h-6 flex-row items-center gap-x-1'>
                  <ClockIcon className='size-4 text-mediumGrey' />
                  <span className='text-xs font-medium text-mediumGrey'>
                    {option.time}
                  </span>
                </div>
              )}
            </Radio>
          )
        })}
      </RadioGroup>
    </div>
  )
}

OptionMessage.propTypes = {
  onClick: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      recommended: PropTypes.bool
    })
  ).isRequired
}
